import request from '../utils/RequestUtil';

function getHolidays(params){
    return request({
        url:'/obtenerDiasContratacion',
        method: 'POST',
        data: params
    });
}

function getConfigDap(){
    return request({
        url:'/obtenerConfigDap',
        method: 'POST',
    });
}

export { getHolidays, getConfigDap };